
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title:
        "Définition Marketing du Bouche-à-Oreille : Décryptage, Stratégies et Avantages",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez la définition marketing du bouche-a-oreille et son importance cruciale pour la croissance de votre entreprise. Informez-vous sur son pouvoir inégalé.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Définition Marketing du Bouche-à-Oreille : Décryptage, Stratégies et Avantages",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Découvrez la définition marketing du bouche-a-oreille et son importance cruciale pour la croissance de votre entreprise. Informez-vous sur son pouvoir inégalé.",
        },
      ],
    };
  },
};
